import {
    GET_CARD_TRANSACTIONS,
    HIDE_ERROR_ALERT,
    HIDE_SUCCESS_ALERT,
    SET_CARD_TRANSACTIONS,
    SHOW_ERROR_ALERT,
    SHOW_SUCCESS_ALERT
} from './transactionsTypes';

const transactionsReducer = (state, action) => {
    switch (action.type) {
        case SHOW_SUCCESS_ALERT:
            return {
                ...state,
                isSuccessAlertOpen: true
            };
        case HIDE_SUCCESS_ALERT:
            return {
                ...state,
                isSuccessAlertOpen: false
            };
        case SHOW_ERROR_ALERT:
            return {
                ...state,
                isErrorAlertOpen: true
            };
        case HIDE_ERROR_ALERT:
            return {
                ...state,
                isErrorAlertOpen: false
            };
        case GET_CARD_TRANSACTIONS:
            return {
                ...state,
                shouldUpdateCardTransactionList: true
            };
        case SET_CARD_TRANSACTIONS:
            return {
                ...state,
                cardTransactions: {
                    ...action.payload.cardTransactions
                },
                shouldUpdateCardTransactionList: false
            };
        default:
            return state;
    }
};

export default transactionsReducer;
